// frontend/src/HomePage.js
import React, { useEffect, useState } from 'react';
import './HomePage.css';

function HomePage() {
  const [fileDaRegistrare, setFileDaRegistrare] = useState([]);
  const [loadingFileDaRegistrare, setLoadingFileDaRegistrare] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailRows, setDetailRows] = useState([]);
  const [detailTitle, setDetailTitle] = useState('');

  const apriDettaglioFile = async (item) => {
  try {
    const token = localStorage.getItem('token');

    setDetailOpen(true);
    setDetailLoading(true);
    setDetailRows([]);
    setDetailTitle(item.RAGIONE_SOCIALE);

    const res = await fetch(
      `https://api.lapegna.xyz/home/file_da_registrare_x_cliente_detail?FK_CLIENTE=${item.ID}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!res.ok) {
      throw new Error(`Errore API: ${res.status}`);
    }

    const data = await res.json();
    setDetailRows(data.fornitori || []);
  } catch (error) {
    console.error('Errore caricamento dettaglio:', error);
    setDetailRows([]);
  } finally {
    setDetailLoading(false);
  }
};


  useEffect(() => {
    try {
      const token = localStorage.getItem('token');

      if (!token) return;

      setLoadingFileDaRegistrare(true);

      fetch('https://api.lapegna.xyz/home/file_da_registrare_x_cliente', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Errore API: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setFileDaRegistrare(data.fornitori || []);
        })
        .catch((error) => {
          console.error('Errore nel caricamento file da registrare:', error);
          setFileDaRegistrare([]);
        })
        .finally(() => {
          setLoadingFileDaRegistrare(false);
        });
    } catch (error) {
      console.error('Errore nella lettura del token:', error);
    }
  }, []);

  return (
    <div>
      <h1>Pagina Principale</h1>
      <p>Benvenuto nella pagina principale. Usa il menu sopra per navigare.</p>

    
      


      <div className="home-card">
        <div className="home-card-header">
          <div className="home-card-icon">📄</div>

          <div>
            <div className="home-card-title">
              Presenti documenti da registrare
            </div>
            <div className="home-card-subtitle">
              Documenti in attesa di registrazione
            </div>
          </div>
        </div>

      <div className="home-card-table">
        <div className="home-card-row home-card-head">
            <span>Amministratore</span>
            <span>N. file</span>
          </div>

          {fileDaRegistrare.map(item => (
           <div
  className="home-card-row clickable-row"
  key={item.ID}
  onClick={() => apriDettaglioFile(item)}
>
  <span>{item.RAGIONE_SOCIALE}</span>

  <span className="badge-file">
    {item["N.FILE"]}
  </span>
</div>


          ))}

        </div>
      </div>

{detailOpen && (
  <div className="modal-overlay" onClick={() => setDetailOpen(false)}>
    <div className="detail-modal" onClick={(e) => e.stopPropagation()}>
      <div className="detail-modal-header">
        <div>
          <h2>Dettaglio documenti da registrare</h2>
          <p>{detailTitle}</p>
        </div>

        <button
          className="modal-close"
          onClick={() => setDetailOpen(false)}
        >
          ×
        </button>
      </div>

      {detailLoading ? (
        <p className="modal-loading">Caricamento...</p>
      ) : detailRows.length === 0 ? (
        <p className="modal-empty">Nessun dettaglio disponibile.</p>
      ) : (
        <div className="detail-list">
          <div className="detail-row detail-head">
            <span>Condominio</span>
            <span>N. file</span>
          </div>

          {detailRows.map((row, index) => (
            <div className="detail-row" key={index}>
              <span>{row.DENOMINAZIONE}</span>
              <span className="badge-file">{row.N_FILE}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
)}


    </div>
  );
}

export default HomePage;